import BookingForm from "../../components/BookingForm";
import { WinterScene } from "../../components/WinterScene";
import { useSeasonAvailability } from "../../hooks/useSeasonAvailability";

/**
 * Loading indicator component shown while fetching season configuration
 * Requirements: 3.1
 */
const LoadingIndicator: React.FC = () => (
  <div
    className="min-h-screen w-full flex items-center justify-center bg-gradient-to-b from-[#0a1628] via-[#1a3a5c] to-[#2d5a87]"
    role="status"
    aria-label="Loading"
  >
    <div className="flex flex-col items-center gap-4">
      <div className="w-12 h-12 border-4 border-white/30 border-t-white rounded-full animate-spin" />
      <span className="text-white text-lg font-medium">Loading...</span>
    </div>
  </div>
);

/**
 * BookingPage Component
 * Conditionally renders WinterScene or BookingForm based on season availability
 * Requirements: 1.3, 1.4, 3.1, 3.2
 */
const BookingPage = () => {
  const { isLoading, isWithinSeason, seasonPeriod } = useSeasonAvailability();

  // Show loading indicator while fetching season configuration (Requirement 3.1)
  if (isLoading) {
    return <LoadingIndicator />;
  }

  // Show WinterScene when outside season (Requirement 1.4)
  // Show BookingForm when within season (Requirement 1.3)
  // Smooth transition handled by conditional rendering (Requirement 3.2)
  return isWithinSeason ? (
    <BookingForm />
  ) : (
    <WinterScene
      seasonStart={seasonPeriod?.seasonStart}
      seasonEnd={seasonPeriod?.seasonEnd}
    />
  );
};

export default BookingPage;
